const createMarkup = (data) => (
    { __html: data }
);

module.exports = createMarkup;
